// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__fZO4f","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1Crq1"};